import React, { MouseEvent } from "react";
import { PDFInvoice } from "../../../savePDF";
import type { Invoice } from "../../../../types/InvoiceTypes";
import { User } from "../../../../types/UserTypes";
import { generatePdfDocument } from "../../../../utils/actions/generatePdfDocument";
import { track } from "../../../../utils/tracking";

export const downloadInvoice = (
  e: MouseEvent<HTMLButtonElement>,
  data: Invoice,
  viewerUser?: User
) => {
  e.preventDefault();

  track("invoice_downloaded", {
    invoice_id: data.id,
    viewer_id: viewerUser?.id,
  });

  generatePdfDocument(<PDFInvoice data={data} />, `Invoice-${data.number}`);
};
